import React, { useRef } from "react";
import { ListItemText } from "@mzc-pdc/ui";
import Tooltip from "@components_v2/Tooltip/tooltip";
import useTextOverflow from "@hooks/useTextOverflow";

/**
 * 목록·메뉴 항목 라벨. 잘림(1줄 말줄임 또는 여러 줄 클램프)이 발생한 경우에만 전체 텍스트를 툴팁으로 노출한다.
 *
 * 메뉴/네비게이션처럼 항목 폭이 컨테이너에 따라 달라지는 곳에서 사용한다. (DAM-306)
 *
 * @param {boolean} disableTooltip 상위에서 이미 전체 라벨 툴팁을 노출하는 경우(접힌 GNB 등) 중복을 막기 위해 사용
 */
const EllipsisListItemText = ({
    primary,
    primaryTypographyProps,
    tooltipPlacement = "right",
    disableTooltip = false,
    ...rest
}) => {
    const ref = useRef(null);
    const isOverflow = useTextOverflow(ref, [primary]);

    return (
        <Tooltip title={isOverflow && !disableTooltip ? primary : ""} placement={tooltipPlacement}>
            <ListItemText primary={primary} primaryTypographyProps={{ ...primaryTypographyProps, ref }} {...rest} />
        </Tooltip>
    );
};

export default EllipsisListItemText;
